import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-field-error-display',
  templateUrl: './field-error-display.component.html',
  styleUrls: ['./field-error-display.component.css']
})
export class FieldErrorDisplayComponent {

  IGNORE_ERROR_FIELDS = ['required'];

  @Input() errorMsg: string;
  @Input() errors: ValidationErrors;
  @Input() displayError: boolean;

  private customErrorMsg;

  constructor() {
    this.customErrorMsg = {
      appMaxValue: 'Valor máximo atingido',
      appMinValue: 'Valor mínimo atingido'
    }
  }

  getErrors(): string[] {
    if (!this.errors) {
      return [];
    }
    const returnData = [];
    Object.keys(this.errors).forEach(field => {
      if (this.IGNORE_ERROR_FIELDS.indexOf(field) === -1) {

        returnData.push(this.customErrorMsg[field] || this.errors[field]);
      }
    });
    return returnData;
  }
}
